import ImportActionsInfoText from './ImportActionsInfoText'

export default ImportActionsInfoText
